import React from 'react';
import {
  Alert,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

import { IPoliciesPanelProps } from './PlanningControlCenter.types';

export default class PlanningPoliciesPanel extends React.PureComponent<
  IPoliciesPanelProps
> {
  render(): React.ReactNode {
    const { policies } = this.props;

    return (
      <Stack spacing={1}>
        {policies.length === 0 ? (
          <Alert severity="info">
            Policies appear after recommendations are accepted or modified.
          </Alert>
        ) : (
          policies.map((policy) => (
            <Paper key={policy.rid} variant="outlined" sx={{ p: 2 }}>
              <Typography fontWeight={700}>{policy.pln}</Typography>
              <Typography variant="body2" color="text.secondary">
                {JSON.stringify(policy.plv)}
              </Typography>
            </Paper>
          ))
        )}
      </Stack>
    );
  }
}
